export default "__VITE_ASSET__DnmfJDHN__"